import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";
import { SERVICES } from "../lib/services";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7", "lg:col-span-6", "lg:col-span-6"];

const onMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
};

const Tile = ({ s, span, i }) => (
  <Reveal className={span} delay={0.06 * i}>
    <Link to={s.path} onMouseMove={onMove} data-testid={`bento-${s.slug}`} className="bento-tile group relative flex h-[420px] flex-col justify-end overflow-hidden rounded-[28px] bg-ink p-7 text-white md:h-[480px] md:p-10">
      <div className="bento-img absolute inset-0">
        <img src={s.image} alt={s.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-ink/0" />
      <div className="bento-spot absolute inset-0" aria-hidden="true" />
      <span className="absolute left-7 top-7 rounded-full bg-ink/70 px-3 py-1.5 font-mono text-xs tracking-[0.2em] text-glint backdrop-blur md:left-10 md:top-10">{s.no} / 06</span>
      <span className="absolute right-7 top-7 flex h-12 w-12 items-center justify-center rounded-full border border-white/25 bg-white/5 backdrop-blur transition-colors duration-300 group-hover:bg-glint group-hover:text-ink md:right-10 md:top-10">
        <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
      </span>
      <div className="relative">
        <h3 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">{s.nav}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-200 md:text-base">{s.short}</p>
      </div>
    </Link>
  </Reveal>
);

export const ServicesBento = () => (
  <section className="bg-porcelain py-28 md:py-40" data-testid="services-bento">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="mb-16 grid gap-8 md:grid-cols-12 md:items-end">
        <div className="md:col-span-7">
          <Reveal><Eyebrow>Services</Eyebrow></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1] tracking-tight text-ink md:text-6xl">
              Six services. <span className="font-serif font-normal italic text-emerald-700">One</span> standard.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.12} className="md:col-span-5">
          <p className="text-base leading-relaxed text-slate-600 md:text-lg">Built around recurring contracts, not one-time jobs. Every service runs from a written scope and a set schedule — the difference is what each space demands.</p>
          <Link to="/services" data-testid="bento-all-services-link" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-ink underline-offset-4 hover:underline">Explore all services <ArrowUpRight className="h-4 w-4" /></Link>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
        {SERVICES.map((s, i) => <Tile key={s.slug} s={s} span={SPANS[i]} i={i} />)}
      </div>
    </div>
  </section>
);
